export default __webpack_public_path__ + "af1e41d5c5793105ef78e25827680aca.png";